
<template lang="pug">
.flex.items-center.dailies-header
  SelectStore.q-mx-sm(
    :storeCode="storeCode"
    :floorCode="floorCode"
    inverted
    @change="onChangeStore"
  )

  SelectPeriod.q-mx-sm(
    :value="beginDate"
    buttons
    inverted
    @change="onChangeDate"
  )

</template>

<script>
import SelectStore from 'components/SelectStore'
import SelectPeriod from 'components/SelectPeriod'

export default {
  components: {SelectStore, SelectPeriod},

  props: {
    storeCode: String,
    floorCode: String,
    beginDate: String,
  },

  methods: {
    onChangeStore(storeCode, floorCode) {
      this.$store.commit('route', {params: {storeCode, floorCode}})
    },

    onChangeDate(beginDate) {
      this.$store.commit('route', {params: {beginDate}})
    },
  },
}
</script>

<style lang="sass">
.dailies-header .q-select
  box-shadow: none !important
  padding: 0 !important

.dailies-header .q-btn
  box-shadow: none !important

</style>
